<a
  class="movie-card__wrapper"
  [routerLink]="navigation ? redirectUrl : null"
  [queryParams]="navigation ? redirectQueryParams : null"
  [state]="{ movie: movie }"
  (click)="onMovieClick()"
>
  <img
    class="background-image"
    [ngClass]="{ portrait: orientation === 'portrait' }"
    loading="lazy"
    [width]="width"
    [height]="height"
    [sizes]="sizes"
    [ngSrc]="movieImg"
    [alt]="movie.title"
  />
</a>
<section class="content" [ngClass]="{ inside: titlePosition === 'inside' }">
  <a
    class="movie-card-title-link hyperlink"
    [routerLink]="navigation ? redirectUrl : null"
    [queryParams]="navigation ? redirectQueryParams : null"
    [state]="{ movie: movie }"
    (click)="onMovieClick()"
  >
    <h2 class="movie-card-title movie-title">{{ movie.title }}</h2>
  </a>
  @if (releaseMessage) {
    <div class="movie-release-info">{{ releaseMessage }}</div>
  }
</section>
@if (showTrailerButton) {
  <ul class="movie-card-trailer">
    <li *ngIf="movie.trailerUrl" class="">
      <button
        class="watchTrailer mainfontbold"
        (clickAfterCheck)="playVideo(movie)"
        [cookiesRequired]="cookiesRequired"
        cookies-check
      >
        <fa-icon [icon]="faPlay"></fa-icon>
        <span [attr.data-translate]="'movie.menu.trailer'">{{ 'movie.menu.trailer' | translate }}</span>
      </button>
    </li>
    <li class="">
      <a class="bold" (click)="onWhereToWatch(movie)" [attr.data-translate]="'movie.menu.watch'">
        <span>{{ 'movie.menu.watch' | translate }}</span>
      </a>
    </li>
  </ul>

  @if (formattedReleaseDate() && showReleaseDate) {
     <div class="movie-card-release-date">
    {{ formattedReleaseDate() }}
  </div>
  }
 
}

<!-- community elements optional section -->
@if (enableCommunityFeature) {
  <div class="film-interaction__container">
    <ui-movie-card-save-button [movie]="movie"></ui-movie-card-save-button>
    <ui-movie-card-watched-button [movie]="movie"></ui-movie-card-watched-button>
  </div>
}
<!-- end community elements optional section -->
